/**
 * Scroll a hash-addressed Settings section into view (#234).
 *
 * Native fragment scrolling does not work on this page: Settings scrolls inside
 * its OWN `overflow-auto` container rather than the document, and a
 * BrowserRouter navigation never touches scroll position at all. So the jump
 * has to be explicit.
 *
 * Focus moves with the scroll so a keyboard user following the Position
 * Tracker's "All alerts… in Settings" link lands IN the section instead of at
 * the top of the page. `preventScroll` keeps that focus call from fighting the
 * `scrollIntoView` that just ran.
 *
 * Returns whether a target was found. Callers may ignore it — it exists so an
 * unknown or empty hash is provably a no-op rather than a thrown error.
 */
export function scrollToHashSection(hash: string, doc: Document = document): boolean {
  const id = hash.replace(/^#/, '');
  if (!id) return false;
  const el = doc.getElementById(id);
  if (!el) return false;
  // No `behavior: 'smooth'`: it ignores prefers-reduced-motion and jsdom does
  // not implement it, so the plain jump is both kinder and testable.
  el.scrollIntoView({ block: 'start' });
  (el as HTMLElement).focus({ preventScroll: true });
  return true;
}
